import { useMemo } from 'react';
import { FieldShell } from './FieldShell';
import type { FieldComponentProps } from './types';

const MIN_YEAR = 1900;
const MAX_YEAR = 2100;

export const YearPickerField = ({ field, value, error, onChange }: FieldComponentProps) => {
  const c = field.constraints || {};
  const currentYear = new Date().getFullYear();

  const years = useMemo(() => {
    let from = MIN_YEAR;
    let to = MAX_YEAR;
    if (c.isPast) to = currentYear;
    if (c.isFuture) from = currentYear;
    const out: number[] = [];
    for (let y = to; y >= from; y--) out.push(y);
    return out;
  }, [c.isPast, c.isFuture, currentYear]);

  return (
    <FieldShell field={field} error={error}>
      <select
        id={field.title}
        className="form-input"
        value={value === '' || value === null || value === undefined ? '' : String(value)}
        onChange={(e) => onChange(e.target.value === '' ? '' : Number(e.target.value))}
      >
        <option value="">Select a year…</option>
        {years.map((y) => (
          <option key={y} value={y}>
            {y}
          </option>
        ))}
      </select>
    </FieldShell>
  );
};
